import type { useEntity } from '@backstage/plugin-catalog-react';

// Taken off useEntity rather than imported: @backstage/catalog-model is not a
// direct dependency of the app, and the card only ever sees what useEntity gives.
type Entity = ReturnType<typeof useEntity>['entity'];
export type EntityLink = NonNullable<Entity['metadata']['links']>[number];

/**
 * The `metadata.links[].type` values cartographer's catalog-etl gives the links
 * it projects from a service's `spec.observability`, in the order the card
 * shows them. They are a contract with `observabilityKinds` in
 * cartographer/tools/catalog-etl/ingest/project.go.
 */
export const OBSERVABILITY_TYPES = ['grafana', 'sentry', 'logs'] as const;

export type ObservabilityType = (typeof OBSERVABILITY_TYPES)[number];

export const isObservability = (link: EntityLink) =>
  (OBSERVABILITY_TYPES as readonly string[]).includes(link.type ?? '');

export const observabilityLinks = (entity: Entity) =>
  (entity.metadata.links ?? []).filter(isObservability);

export const otherLinks = (entity: Entity) =>
  (entity.metadata.links ?? []).filter(link => !isObservability(link));
